import React, { type FC } from 'react';

export const TicketSvg: FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 13H14V11H10V13ZM16 18H15.587C14.984 16.563 13.754 15.576 12 15.576C10.246 15.576 9.016 16.563 8.413 18H8V6H8.413C9.016 7.437 10.246 8.424 12 8.424C13.754 8.424 14.984 7.437 15.587 6H16V18ZM14 4C14 4 14 6.424 12 6.424C10 6.424 10 4 10 4H6V20H10C10 20 10 17.576 12 17.576C14 17.576 14 20 14 20H18V4H14Z"
                fill="#3A3247"
            />
        </svg>
    );
};
